import {
  Box,
  Flex,
  Image,
  InputGroup,
  InputRightElement,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import oneIcon from "../../assets/images/salesManagement/happyAsset 1 1.svg";
import twoIcon from "../../assets/images/salesManagement/happyAsset 4 1.svg";
import threeIcon from "../../assets/images/salesManagement/happyAsset 5 1.svg";
import DatePicker from "react-datepicker";
import SearchableSelect from "../../components/selectForm";
import { useCategories } from "../../categorys/SalesManagement/honor";
import { useTab } from "../../contexts/useTab";
import { formatTableValue } from "./formatTable";
import { useHonor } from "../../hooks/useHonor";

const TableHonor = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [projectId, setProjectId] = useState(null);
  const { honorTab, setHonorTab } = useTab();
  const [shouldFetch, setShouldFetch] = useState(false);

  const tabInfo = [
    {
      title: "Cá nhân",
      content: 0,
    },
    {
      title: "Vùng",
      content: 1,
    },
    {
      title: "Khối",
      content: 2,
    },
  ];

  const {
    honorData,
    // refetch,
    isLoading,
    isRefetching,
  } = useHonor(honorTab + 1, projectId, startDate, endDate);

  const setInfoTabData = (index) => {
    setHonorTab(index);
  };

  const tableData = {
    headers: [
      {
        label: "Thứ hạng",
        key: "",
      },
      {
        label:
          honorTab === 0
            ? "Tên nhân viên"
            : honorTab === 1
            ? "Tên vùng"
            : "Tên khối",
        key: "name",
      },
      {
        label: "Doanh thu",
        key: "jobTitle",
      },
    ],
    data: honorData,
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );
  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Box
            p={"16px 0px 12px 0px"}
            maxH={"111vh"}
            overflowY={"auto"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
              "&::-moz-scrollbar": {
                width: "4px",
              },
              "&::-moz-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
            }}
          >
            <Text
              fontSize={{ base: "20px" }}
              fontWeight={600}
              p={"0px 16px 0px 16px"}
            >
              Bảng vinh danh
            </Text>
            <Flex
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={{ base: "32px" }}
              mt={"20px"}
            >
              <Flex
                gap={{ base: "16px" }}
                flex={"1"}
                flexDirection={{ base: "column" }}
              >
                <Flex
                  alignItems={"center"}
                  p={"4px"}
                  bg={"var(--color-background-2)"}
                  m={"0px 16px 0px 16px"}
                >
                  {tabInfo.map((e, index) => {
                    return (
                      <Flex
                        alignItems={"center"}
                        justifyContent={"center"}
                        key={index}
                        flex={1}
                      >
                        <Flex
                          alignItems={"center"}
                          justifyContent={
                            index === 0 ? "flex-start" : "flex-end"
                          }
                          onClick={() => setInfoTabData(index)}
                          cursor={"pointer"}
                          zIndex={"10"}
                          flex={1}
                        >
                          <Flex
                            w={"100%"}
                            bg={
                              honorTab === index ? "var(--color-secondary)" : ""
                            }
                            justifyContent={"center"}
                            alignItems={"center"}
                            pt={"10px"}
                            pb={"9px"}
                            borderRadius={"6px"}
                          >
                            <Text
                              fontSize={{
                                base: "16px",
                              }}
                              fontWeight={500}
                              lineHeight={"normal"}
                              fontFamily="var(--font-heading-main)"
                              color={
                                honorTab === index
                                  ? "var(--color-main)"
                                  : "var(--color-black-5)"
                              }
                              textAlign={"center"}
                              whiteSpace="nowrap"
                            >
                              {e?.title}
                            </Text>
                          </Flex>
                        </Flex>
                        {index !== tabInfo.length - 1 && index !== honorTab && (
                          <Flex justifyContent={"flex-end"}>
                            <Box
                              w={"1px"}
                              h={"12px"}
                              bg={"var(--color-black-2)"}
                            ></Box>
                          </Flex>
                        )}
                      </Flex>
                    );
                  })}
                </Flex>
                <Flex
                  alignItems={"center"}
                  gap={{ base: "16px" }}
                  p={"0px 16px 0px 16px"}
                >
                  <InputGroup w={"100%"} maxW={"255px"} zIndex={3}>
                    <DatePicker
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      dateFormat="dd/MM/yyyy"
                      locale="vi"
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={true}
                      placeholderText="Từ ngày - Đến ngày"
                      className="datePickerStyle"
                    />
                    {!startDate && !endDate && (
                      <InputRightElement pointerEvents="none" h={"44px"}>
                        <Image src={calendarIcon} />
                      </InputRightElement>
                    )}
                  </InputGroup>
                  <SearchableSelect
                    isShowSearch={true}
                    options={projects}
                    initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                    setValue={setProjectId}
                  />
                </Flex>
                <Box width={"100%"} height={"100%"}>
                  <Skeleton isLoaded={!isLoading && !isRefetching}>
                    <TableContainer
                      w={"100%"}
                      maxH="calc(100vh - 350.5px)"
                      overflowY="auto"
                    >
                      <Table w={"100%"} variant="unstyled">
                        <Thead
                          position="sticky"
                          top="0"
                          zIndex="1"
                          w={"100%"}
                          h={"41px"}
                          color="white"
                          fontWeight="400"
                          borderBottom={"1px solid var(--color-black-2)"}
                          backgroundColor="var(--fill-avatar)"
                        >
                          <Tr h={{ base: "41px" }}>
                            {tableData.headers.map((e, index) => {
                              let width = "auto";
                              let textAlign = "auto";
                              if (e.key === "") {
                                width = "max-content";
                                textAlign = "start";
                              } else if (e.key === "name") {
                                width = "60%";
                                textAlign = "start";
                              } else {
                                width = "auto";
                                textAlign = "end";
                              }
                              return (
                                <Td
                                  display={
                                    e.key === "" ? "block" : "table-cell"
                                  }
                                  p={"16px 16px 8px 16px"}
                                  key={index}
                                  border={"none"}
                                  color={"#51607B"}
                                  fontSize={{ base: "14px" }}
                                  w={width}
                                >
                                  <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        </Thead>
                        <Tbody w={"100%"} h={"100%"}>
                          {tableData.data?.length > 0 ? (
                            tableData.data?.map((e, rowIndex) => {
                              const items = { ...e };
                              delete items.id;
                              delete items.edit;
                              delete items.detail;
                              const keyValues = Object.keys(items);
                              return (
                                <Tr
                                  key={rowIndex}
                                  h={rowIndex === 2 ? "64px" : "32px"}
                                  position={"relative"}
                                  _after={
                                    rowIndex === 2
                                      ? {
                                          content: '""',
                                          position: "absolute",
                                          bottom: "0",
                                          left: "0",
                                          w: "95%",
                                          h: "1px",
                                          m: "0px 16px",
                                          bg: "var(--color-black-2)",
                                        }
                                      : {}
                                  }
                                >
                                  <Td
                                    p={"16px 16px 8px 16px"}
                                    w={"max-content"}
                                    textAlign={"center"}
                                    display={"block"}
                                  >
                                    {rowIndex === 0 ? (
                                      <Image
                                        src={oneIcon}
                                        w={{ base: "32px", lg: "48px" }}
                                        h={{ base: "22.5px", lg: "28.5px" }}
                                      />
                                    ) : rowIndex === 1 ? (
                                      <Image
                                        src={twoIcon}
                                        w={{ base: "32px", lg: "48px" }}
                                        h={{ base: "22.5px", lg: "28.5px" }}
                                      />
                                    ) : rowIndex === 2 ? (
                                      <Image
                                        src={threeIcon}
                                        w={{ base: "32px", lg: "48px" }}
                                        h={{ base: "22.5px", lg: "28.5px" }}
                                      />
                                    ) : (
                                      <Text
                                        w={{ base: "32px", lg: "48px" }}
                                        color={
                                          "var(--color-option-employee-hover)"
                                        }
                                      >
                                        {rowIndex + 1}
                                      </Text>
                                    )}
                                  </Td>
                                  {keyValues.map((keyvalue, index) => {
                                    let width = "auto";
                                    let widthText = "100%";
                                    let textAlign = "auto";
                                    let whiteSpace = "inherit";
                                    if (keyvalue === "") {
                                      width = "max-content";
                                      textAlign = "start";
                                    } else if (keyvalue === "name") {
                                      width = "60%";
                                      textAlign = "start";
                                    } else {
                                      width = "auto";
                                      textAlign = "end";
                                      whiteSpace = "inherit";
                                    }
                                    return (
                                      <Td
                                        p={"16px 16px 8px 16px"}
                                        w={width}
                                        key={index}
                                      >
                                        <Box
                                          fontSize={{ base: "14px" }}
                                          lineHeight={"19.6px"}
                                          textAlign={"start"}
                                          fontWeight={500}
                                          color={"var(--color-info-employee)"}
                                          w={widthText}
                                          whiteSpace={whiteSpace}
                                          overflow="hidden"
                                          textOverflow="ellipsis"
                                          display="-webkit-box"
                                          sx={{
                                            WebkitLineClamp: "2",
                                            WebkitBoxOrient: "vertical",
                                          }}
                                        >
                                          {formatTableValue(
                                            e[keyvalue],
                                            keyvalue
                                          )}
                                        </Box>
                                      </Td>
                                    );
                                  })}
                                </Tr>
                              );
                            })
                          ) : (
                            <Tr>
                              <Td
                                colSpan={tableData.headers.length}
                                textAlign="center"
                                padding={"40px 0"}
                              >
                                Không có dữ liệu
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Skeleton>
                </Box>
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default TableHonor;
